<div class="card p-0 animate__animated animate__fadeIn">
  <div class="logo-auth">
    <img src="../../../assets/images/logo-auth.png" alt="" />
  </div>
  <div class="p-4">
    @if(isLinkExpired) {
    <h5 class="text-center mb-4 inter-Regular">Reset Password Link Expired</h5>
    <p class="text-center">
      <!--The link was valid for a duration of two hours and has now expired. Or,
        the link has already been used and cannot be reused.-->
      The link has expired or already been used.
    </p>
    <div class="mb-4 text-center pt-2">
      <a
        routerLink="/login"
        class="btn btn-warning rounded-pill text-white w-150px"
      >
        Return to Login
      </a>
    </div>
    }@else {
    <h2 class="text-center mb-4 inter-Regular">Reset Password</h2>
    <form
      #frm="ngForm"
      (submit)="frm.form.valid && onSubmit(frm)"
      [mustMatch]="['password', 'confirm_password']"
    >
      <div class="mb-3">
        <label for="password" class="form-label">New Password</label>
        <input
          type="password"
          class="form-control"
          name="password"
          ngModel
          #password="ngModel"
          pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&'#'])[A-Za-z\d@$!%*?&'#']{8,}$"
          required
        />
        @if(frm.submitted && password.invalid) {
        @if(password.hasError('required')) {
        <span class="m-0 text-danger">Password is required.</span>
        } @if(password.hasError('pattern')) {
        <span class="m-0 text-danger"
          >Password must have at least 8 characters, include at least one
          uppercase letter, one lowercase letter, one number, and one special
          character</span
        >
        }}
      </div>
      <div class="mb-3">
        <label for="email" class="form-label">Confirm Password</label>
        <input
          type="password"
          class="form-control"
          name="confirm_password"
          ngModel
          #confirmPassword="ngModel"
          required
        />
        @if(frm.submitted && confirmPassword.invalid) {
        @if(confirmPassword.hasError('required')) {
        <span class="text-danger">Confirmation password is required.</span>
        }@else if(confirmPassword.hasError('mustMatch')) {
        <span class="text-danger">Confirm password do not match.</span>
        }}
      </div>
      <div class="mb-4">
        <!-- <button type="submit" class="btn btn-llink float-start rounded-pill w-150px">Cancel</button> -->
        <a
          routerLink="/login"
          class="me-2 btn btn-outline-light float-start rounded-pill w-150px"
        >
          Cancel
        </a>
        <button
          type="submit"
          class="btn btn-warning rounded-pill text-white w-150px float-end"
        >
          Submit
        </button>
      </div>
    </form>
    }
  </div>
</div>
